import type { FC, ReactNode } from 'react'
import type { Insight } from '@/constants/dashboard'

import { ArrowRight, Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'

interface InsightCardProps {
    insight: Insight
    className?: string
}

const TONE: Record<Insight['tone'], string> = {
    positive: 'bg-sage',
    warning: 'bg-gold',
    neutral: 'bg-terracotta'
}

export const InsightCard: FC<InsightCardProps> = ({ insight, className }): ReactNode => {
    return (
        <div className={cn('rounded-xl border border-burgundy/[0.08] bg-paper/70 p-3.5', className)}>
            <div className='flex items-center gap-2'>
                <span className='flex size-6 items-center justify-center rounded-full bg-burgundy text-gold'>
                    <Sparkles aria-hidden='true' className='size-3.5' />
                </span>

                <span className='font-mono text-[10px] uppercase tracking-[0.14em] text-stone'>Veyra AI</span>
                <span aria-hidden='true' className={cn('ml-auto size-1.5 rounded-full', TONE[insight.tone])} />
            </div>

            <p className='mt-3 text-[13px] font-medium leading-snug text-burgundy'>{insight.title}</p>
            <p className='mt-1.5 text-xs leading-relaxed text-stone-dark'>{insight.body}</p>

            <p className='mt-3 inline-flex items-center gap-1 text-[11px] font-medium text-gold-dark'>
                {insight.action}
                <ArrowRight aria-hidden='true' className='size-3' />
            </p>
        </div>
    )
}
